export function run(){
    return {
        save(modal_id, callback){
            helper.loader(true);
            axios.post($('#' + modal_id + ' form').attr('data-action'), $('#' + modal_id + ' form').serialize())
            .then(function (response) {
                $('#' + modal_id).modal('hide');
                swal({
                    title: 'Sikeres mentés',
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                }).then(function(){
                    if(callback != undefined){
                        callback(response);
                    }else{
                        window.location.href = response.data.url;
                    }
                });
                helper.loader(false);
            })
            .catch(function (error) {
                if (error.response != undefined && error.response.data.errors != undefined) {
                    for (var index in error.response.data.errors) {
                        $('#' + modal_id + ' form'). find('.invalid-feedback.' + index.replace('.', '-')).html(error.response.data.errors[index].join('<br/>')).addClass('d-block');
                    }
                }
                helper.loader(false);
            });
        },
        remove(id, url, callback){
            swal({
                title: 'Biztos törölni szeretné?',
                text: "",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Mégsem',
                confirmButtonText: 'Törlés',
                padding: '2em'
            }).then(function (result) {
                if (result.value) {
                    helper.loader(true);
                    axios.delete(url).then(function (response) {
                        helper.loader(false);
                        if(response.data.message == 'success'){
                            if(callback != undefined){
                                callback(response);
                            }else{
                                $(id).remove();
                            }
                            swal({
                                title: 'Sikeres törlés',
                                type: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            })
                        }else{
                            swal({
                                title: 'Sikertelen törlés',
                                type: 'error',
                                timer: 2000,
                                showConfirmButton: false
                            })
                        }
                    }).catch(function (error) {
                        helper.loader(false);
                        swal({
                            title: 'Sikertelen törlés',
                            type: 'error',
                            timer: 2000,
                            showConfirmButton: false
                        })
                    });
                }
            });
        },
        edit(modal_id, url, callback){
            helper.loader(true);
            if(url == undefined){
                url = $('#' + modal_id + ' form').attr('data-action');
            }
            axios.get(url)
            .then(function (response) {
                if(callback){
                    callback(modal_id, response);
                }else{
                    for(let index in response.data.datas){
                        let data = response.data.datas[index];
                        if($('#' + modal_id + ' form').find('[name="' + index + '"]').is('[type="radio"], [type="checkbox"]')){
                            $('#' + modal_id + ' form').find('[name="' + index + '"]').prop('checked', false);
                            $('#' + modal_id + ' form').find('[name="' + index + '"]').removeAttr('checked');
                            $('#' + modal_id + ' form').find('[name="' + index + '"][value="' + data + '"]').prop('checked', true);
                            $('#' + modal_id + ' form').find('[name="' + index + '"][value="' + data + '"]').attr('checked', 'checked');
                        }else{
                            $('#' + modal_id + ' form').find('[name="' + index + '"]').val(data);
                            if($('#' + modal_id + ' form').find('[name="' + index + '"]').is("select")){
                                ss.trigger('change');
                            }
                        }
                    }
                }
                $('#' + modal_id).modal('show');
                helper.loader(false);
            })
            .catch(function (error) {
                helper.loader(false);
                swal({
                    title: 'Sikertelen betöltés',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                })
            });
        },
        update(modal_id, callback){
            helper.loader(true);
            var url = $('#' + modal_id + ' form').attr('data-action');
            if($('#' + modal_id + ' form input[name="id"]').length > 0 && $('#' + modal_id + ' form input[name="id"]').val() != ''){
                url = $('#' + modal_id + ' form').attr('data-action').replace(':id', $('#' + modal_id + ' form input[name="id"]').val());
            }
            axios.put(url, $('#' + modal_id + ' form').serialize())
            .then(function (response) {
                if(response.data.datas != undefined){
                    for(let index in response.data.datas){
                        let data = response.data.datas[index];
                        $('#' + response.data.container).find('[data-name="' + index + '"]').html(data);
                    }
                }
                if(callback != undefined){
                    callback(response);
                }
                $('#' + modal_id).modal('hide');
                swal({
                    title: 'Sikeres módosítás',
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                }).then(function(){
                    if(response.data.url != undefined){
                        window.location.href = response.data.url;
                    }
                });
                helper.loader(false);
            })
            .catch(function (error) {
                if (error.response != undefined && error.response.data.errors != undefined) {
                    for (var index in error.response.data.errors) {
                        $('#' + modal_id + ' form'). find('.invalid-feedback.' + index.replace('.', '_')).html(error.response.data.errors[index].join('<br/>')).addClass('d-block');
                    }
                }
                helper.loader(false);
            });
        },

        put(route, params, callback){
            helper.loader(true);
            axios.put(route, params)
            .then(function (response) {
                if(callback != undefined){
                    callback(response);
                }
                swal({
                    title: 'Sikeres módosítás',
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                }).then(function(){
                    if(response.data.url != undefined){
                        window.location.href = response.data.url;
                    }
                });
                helper.loader(false);
            })
            .catch(function (error) {
                helper.loader(false);
                swal({
                    title: error.response.data.message != undefined ? error.response.data.message : 'Sikertelen',
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                })
            });
        },

        confirm(callback){
            swal({
                title: 'Biztos törölni szeretné?',
                text: "",
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Mégsem',
                confirmButtonText: 'Törlés',
                padding: '2em'
            }).then(function (result) {
                callback();
            });
        },

        info(modal_id, url){
            helper.loader(true);
            axios.get(url)
            .then(function (response) {
                if(response.data.datas != undefined){
                    for(let index in response.data.datas){
                        let data = response.data.datas[index];
                        $('#' + modal_id).find('[data-name="' + index + '"]').html(data);
                    }
                }
                helper.loader(false);
                $('#' + modal_id).modal('show');
            });
        },

        systemAlert(type, msg){
            window.addEventListener("load", function(){
                swal({
                    title: '',
                    text: msg,
                    type: type,
                    showCancelButton: false,
                    showConfirmButton: false,
                    padding: '1em',
                    timer: 3000
                });
            });
        },
        export(url, element){
            window.location = url + '?' + $(element).serialize();
            
            
        },
        jquery(){
            $('form').on('focus', 'input, select, textarea', function(){
                $(this).parents('.form-group').find('.invalid-feedback').removeClass('d-block');
            });

            $('form').on('focus', 'input', function(){
                if(parseFloat($(this).val()) == 0){
                    $(this).val('');
                }
            });

            if($('.datepicker-range').length > 0){
                var f3 = flatpickr($('.datepicker-range'), {
                    mode: "range",
                    dateFormat: "Y. m. d",
                    locale: 'hu',
                    onClose: function(selectedDates, dateStr, instance) {
                        $(instance.element).parents('.input-group').find('.input-' + $(instance.element).data('input-name') + '-start').val(selectedDates[0] ? helper.getDate(selectedDates[0]) : null);
                        $(instance.element).parents('.input-group').find('.input-' + $(instance.element).data('input-name') + '-end').val(selectedDates[1] ? helper.getDate(selectedDates[1]) : null);
                    },
                });
            }

            if($('.datepicker').length > 0){
                var f3 = flatpickr($('.datepicker'), {
                    enableTime: true,
                    dateFormat: "Y. m. d H:i",
                    locale: 'hu',
                    onClose: function(selectedDates, dateStr, instance) {
                        $(instance.element).parents('.input-group').find('.input-' + $(instance.element).data('input-name')).val(helper.getDateTime(selectedDates[0]))
                    }
                });
            }
        }
    }
}
